<template>
  <div>
    <b-container fluid class="gen-header">
      <b-row>
        <b-col sm="12">
          <div class="childs">
            <div class="page-title">Our Services</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <service-page></service-page>
    <call-us></call-us>
  </div>
</template>

<script>
// @ is an alias to /src
import ServicePage from "@/components/ServicePage.vue";
import CallUs from "@/components/CallUs.vue";

export default {
  created() {
    document.title = "Our Services";
  },
  name: "Services",
  data() {
    return {
      drawer: true,
      images: {
        headImage: require("@/assets/bgparallax-01.jpg")
      },
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Our Services",
          active: true
        }
      ]
    };
  },
  components: {
    "service-page": ServicePage,
    "call-us": CallUs
  }
};
</script>
<style scoped></style>
